import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Col, Row, Button } from 'reactstrap';
import { change_inner_side_bar_visibility } from '../../slices/SideBarCust/reducer';

const BreadCrumb = ({ title, pageTitle }) => {

    const { inner_side_value } = useSelector((state)=>state.SidebarCust)
    const { bread_crum_title , bread_crum_page_title  } = useSelector((state)=> state.Header)
    const navigate = useNavigate();


const dispatch=useDispatch();

    const open_inner_side_bar = ()=>{
        dispatch(change_inner_side_bar_visibility('visiblity'))
    }

    
    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <div>
                            <h4 className="mb-sm-0">{bread_crum_title}</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><Link onClick={(e) => { 
        e.preventDefault(); 
        navigate(-1);   // go back one step in history
    }}>{bread_crum_page_title}</Link></li>
                                    <li className="breadcrumb-item active">{bread_crum_title}</li>
                                </ol>
                            </div>
                        </div>
                        <div className='mob-side-cust-but'>
                            {/* on click this button add class on sidebar (visible) */}
                          {/* <Button onClick={open_inner_side_bar} color="primary" className="btn-icon" outline> <i className="  ri-bar-chart-horizontal-line" /> </Button> */}
                          {location.pathname === "/Configuration" ? (
                                <Button onClick={open_inner_side_bar} color="secondary" className="btn-icon" outline> <i className="ri-bar-chart-horizontal-line" /> </Button>
                            ) : (
                                <div></div>
                            )}
                        </div>
                    </div>
                    
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;